// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
// import { getAnalytics } from "firebase/analytics";
import { getStorage } from "firebase/storage";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyCXGtZ7V0eWTu_Y9-fL__KtkOwDZrJM75U",
  authDomain: "annapurnasweetshop.firebaseapp.com",
  projectId: "annapurnasweetshop",
  storageBucket: "annapurnasweetshop.appspot.com",
  messagingSenderId: "624164854394",
  appId: "1:624164854394:web:d6affa6cd5569fde5cf9c3",
  measurementId: "G-HYH9YFWDC4"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const storage = getStorage(app);
export default storage;